import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { terciaryColor } from 'designTokens/colors';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  Paper,
  PrimarySpanMedium,
  SecondarySpanMedium,
} from 'atoms/StyledComponents';
// import '../../../../BrokerPage/molecules/BrokerSummaryCard/styles.scss';
import '../style.scss';
import { Button } from 'react-bootstrap';
import unknownBusinessLogo from 'assets/unknown-business-logo.png';
import { FormattingUtils } from "utils/index";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link_hover: {
      '&:hover': {
        textDecoration: 'underline !important',
        color: terciaryColor,
        cursor: 'pointer',
      },
    },
    broker_name_hover: {
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'Pointer',
      },
    },
  }),
);

export interface BrokerCardProps {
  brokerInfo?: any;
  onClickBroker?: () => void;
  imageUrl: string;
}

export const BrokerCard = ({ brokerInfo, onClickBroker, imageUrl }: BrokerCardProps) => {
  const classes = useStyles();

  return (
    <Paper className="brocker-card">
      <div className="brocker-card__image">
        {
          imageUrl ? (
            <img
              src={imageUrl}
              onError={({ currentTarget }) => {
                currentTarget.onerror = () => {
                  currentTarget.src = unknownBusinessLogo;
                  currentTarget.onerror = null; // prevents further looping
                };
                currentTarget.src = `https://logo.clearbit.com/${brokerInfo?.website}`;
              }}
              alt=""
            ></img>
          ) : (
            <img src={unknownBusinessLogo} alt="" className="frame2" />
          )
          // <Skeleton variant="rect" width={100} height={100} style={{ borderRadius: "10px"}} />
        }
      </div>

      <div className="brocker-card__content">
        <div>
          <PrimarySpanMedium
            className={classes.broker_name_hover}
            onClick={onClickBroker}
            style={{ fontSize: '20px' }}
          >
            {brokerInfo ? (
              FormattingUtils.formatUpperCasing(brokerInfo?.masterBrokerName)
            ) : (
              <Skeleton
                style={{ display: 'inline-block' }}
                variant="rect"
                width={200}
              />
            )}
          </PrimarySpanMedium>
          <span className="bd-address">
            HQ in{' '}
            {brokerInfo ? (
              brokerInfo?.headquarters
            ) : (
              <Skeleton
                style={{ display: 'inline-block' }}
                variant="rect"
                width={100}
              />
            )}
          </span>
        </div>
      </div>

      <div className="brocker-card__moreinfo">
        <Button
          onClick={onClickBroker}
          variant="primary"
          className="light"
        >
          More Info
        </Button>
      </div>

      <div className="broker-stats">
        {brokerInfo ? (
          <>
            <SecondarySpanMedium
              style={{ fontWeight: 700, marginBottom: '5px' }}
            >
              $
              {FormattingUtils.formatNumberAbbrev(
                brokerInfo?.commissions,
              )}{' '}
              Commissions Reported
            </SecondarySpanMedium>
            <span>${FormattingUtils.formatNumberAbbrev(brokerInfo?.carrierPremiums)}{' '} Carrier Premiums</span>
            <span>{brokerInfo?.officeLocationCount} Office Locations</span>
            <span>{brokerInfo?.clientCount} Clients</span>
            <span>{brokerInfo?.contactCount} Contacts</span>
          </>
        ) : (
          <>
            <p>
              <Skeleton
                style={{ display: 'inline-block' }}
                variant="rect"
                width={200}
              />
            </p>
            <span>
              <Skeleton
                style={{ display: 'inline-block' }}
                variant="rect"
                width={175}
              />
            </span>
            <span>
              <Skeleton
                style={{ display: 'inline-block' }}
                variant="rect"
                width={150}
              />
            </span>
            <span>
              <Skeleton
                style={{ display: 'inline-block' }}
                variant="rect"
                width={100}
              />
            </span>
          </>
        )}
      </div>
    </Paper>
  );
};